// extracted by mini-css-extract-plugin
export default {"main":"DashboardPage_main__OxYZB","dashboardTitle":"DashboardPage_dashboardTitle__reJZ3"};